<template>
  <div class="app-container">
    <el-card class="card" :style="{ width: isMobile ? '100%' : '95%' }">
      <h2>2026-06-25 V5.0</h2>
      <p>新增第三方账号绑定和解绑</p>
      <p>优化客户端页面布局，分类数据加载更快，使用更流畅</p>
      <p>新用户首次使用时，系统会自动创建默认分类，减少手动配置步骤</p>
      <p>添加网站时支持 AI 智能匹配，可自动识别网站名称、描述和图标信息</p>
      <p>优化网站图标获取效果，提升部分网站图标显示成功率</p>
      <p>优化列表分页和排序体验，数据查询更稳定</p>
      <p>修复登录页背景图片无法正常显示的问题</p>
      <p>修复自定义导航添加网站时弹窗无法显示的问题</p>
      <p>修复网络超时或接口异常时误清除登录状态的问题</p>
      <p>优化添加网站相关接口，提升网站信息匹配稳定性</p>
      <el-divider />

      <h2>2024-12-31 V4.3</h2>
      <p>
        新增(我的导航、自定义导航)：工具栏可展开和隐藏；导入系统导航网站，未选择分类时，自动同步系统分类结构
      </p>
      <p>
        新增(系统导航)：添加和用户导航一致的编辑页面，可实时查看编辑后的消息
      </p>
      <p>perf(我的导航、自定义导航)：优化获取数据效率，提高页面响应时间</p>
      <el-divider />

      <h2>2024-11-15 V4.2</h2>
      <p>
        新增(我的导航)：可在此页面进行编辑和分享操作，简化自定义导航步骤，页面更简洁，操作更简单
      </p>
      <el-divider />

      <h2>2023-07-31 V4.1</h2>
      <p>修复(主题)：未登录切换主题提示登录已过期</p>
      <p>修复(分享页面)：输入密码点击确定无响应</p>
      <p>修复(图片背景)：图片上传后，透明背景变为黑色</p>
      <p>修复(图片上传)：用户上传网站提示无权限访问</p>
      <el-divider />

      <h2>2023-05-07 V4.0</h2>
      <p>重构前后端，前端升级为 Vue3，后端重构为代码规范</p>
      <el-divider />

      <h2>2021-12-16 V3.4</h2>
      <p>修复统计网站点击量不正确</p>
      <el-divider />

      <h2>2021-11-12 V3.3</h2>
      <p>购买云服务器，提升访问性能</p>
      <el-divider />

      <h2>2021-05-28 V3.2.6</h2>
      <p>导航网站由格姗知识圈导航更名为格姗导航</p>
      <p>导航网站域名改为更简短的域名，新域名为 gesdh.cn</p>
      <el-divider />

      <h2>2021-04-19 V3.2.6</h2>
      <p>解决第三方搜索提示，网络不好一直在转圈圈问题</p>
      <el-divider />

      <h2>2021-04-18 V3.2.5</h2>
      <p>解决第三方搜索提示，几秒后自动消失问题</p>
      <el-divider />

      <h2>2021-04-15 V3.2.4</h2>
      <p>添加导航分享是否显示用户卡片信息</p>
      <el-divider />

      <h2>2021-04-14 V3.2.3</h2>
      <p>优化首页和分享页面加载太慢，提高用户体验</p>
      <p>修复网站没有描述时，鼠标放在此网站上显示空白提示</p>
      <el-divider />

      <h2>2021-03-28 V3.2.2</h2>
      <p>添加 QQ、Gitee、Github 第三方账号登录</p>
      <p>购买 CDN ，加快访问速度</p>
      <el-divider />

      <h2>2021-03-07 V3.2.1</h2>
      <p>新增网站时，输入网站地址，点击自动匹配，即可匹配对应的网站内容</p>
      <el-divider />

      <h2>2021-03-06 V3.2.0</h2>
      <p>添加鼠标放在网站时，显示描述</p>
      <p>添加最新收录显示</p>
      <p>添加设置导航网站为首页教程</p>
      <p>添加导航网站更新记录</p>
      <el-divider />

      <h2>2021-01-24 V3.1.0</h2>
      <p>添加评论功能</p>
      <p>分享的导航，分享者添加PRO文字颜色变化</p>
      <p>修复IE11浏览器和PC微信打开报错问题</p>
      <el-divider />

      <h2>2021-01-14 V3.0.4</h2>
      <p>去除内置网站跳转，直接跳转对应的网站，提高用户体验</p>
      <p>第三方搜索添加搜索提示</p>
      <el-divider />

      <h2>2020-12-30 V3.0.3</h2>
      <p>添加导入浏览器书签说明</p>
      <p>分享页面添加一键采集功能</p>
      <el-divider />

      <h2>2020-12-30 V3.0.2</h2>
      <p>添加采集网站图标</p>
      <p>优化菜单修改交互</p>
      <el-divider />

      <h2>2020-11-20 V3.0.1</h2>
      <p>导航首页图片添加懒加载，加快图片显示</p>
      <el-divider />

      <h2>2020-10-26 V3.0.0</h2>
      <p>版本升级为3.0.0</p>
      <p>可添加自定义布局</p>
      <p>添加实时预览编辑页面，可直接看到自定义导航效果</p>
      <el-divider />

      <h2>2020-09-20 V2.1.2</h2>
      <p>优化添加菜单和网站</p>
      <p>添加鼠标放在网站时，网站标题改变颜色</p>
      <p>更新验证码显示，更加美观，便于识别</p>
      <el-divider />

      <h2>2020-09-13 V2.1.1</h2>
      <p>添加忘记密码功能</p>
      <p>添加网站图片时，可从图片库选择</p>
      <p>添加导入系统菜单时，可选择导入菜单下的所有网站</p>
      <p>分享页面：移动端显示密码对话框问题</p>
      <el-divider />

      <h2>2020-08-22 V2.1.0</h2>
      <p>添加首页右下角显示搜索图标和弹出搜索</p>
      <p>添加不开启自定义导航时，首页显示添加图标</p>
      <el-divider />

      <h2>2020-08-17 V2.0.2</h2>
      <p>解决菜单有特殊字符（如：/）不能瞄点定位问题</p>
      <p>解决导航首页展示的网站不按菜单排序问题</p>
      <el-divider />

      <h2>2020-08-16 V2.0.1</h2>
      <p>关于本站移动端访问问题</p>
      <p>关于本站不能访问问题</p>
      <el-divider />

      <h2>2020-08-15 V2.0.0</h2>
      <p>自己独立开发导航网站，并支持自定义导航</p>
      <el-divider />

      <h2>2020-07-11 V1.0.0</h2>
      <p>导航网站正式开通，使用开源项目搭建</p>
    </el-card>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useDefaultClientCategories } from '@/composables/useDefaultClientCategories'

const store = useStore()
const setDefaultCategories = useDefaultClientCategories()

// 是否移动端
const isMobile = computed(() => store.getters['app/isMobile'])

// 更新日志页没有专属分类接口，使用默认导航分类填充左侧栏
setDefaultCategories()
</script>
<style scoped lang="scss">
.card {
  margin: auto;
}
</style>
